import React from "react";

import Part_1 from '../../img/part/part_1.webp'
import Part_2 from '../../img/part/part_2.webp'
import Part_3 from '../../img/part/part_3.webp'
import Part_4 from '../../img/part/part_4.webp'

const EventPartnersCenter = ({ partnersBaseData = [] }) => {

    return (
        <section className="">

            <div className="container max-w-screen-xl mx-auto mb-7 md:mb-16 lg:mb-32">
                <div className="mb-4 md:mb-12">
                    <h2 className="font-bold text-center uppercase text-[24px] sm:text-[26px] text-[#000] mb-3 mb-7">Партнери</h2>
                    <div className="flex flex-col justify-center  gap-5 pb-5 md:flex-row">
                        <a href="https://kyivstar.ua/" target="_blank" rel="noopener noreferrer" class="w-full max-w-[180px] flex bg-white p-2 justify-center items-center">
                            <img src={Part_1}  className="inline-block object-contain" alt="Партнер"/>
                        </a>

                        <a href="https://kse.university/" target="_blank" rel="noopener noreferrer" class="w-full max-w-[180px] flex bg-white p-2  justify-center items-center">
                            <img src={Part_2}  className="inline-block object-contain" alt="Партнер"/>
                        </a>

                        <a href="https://parallel.ua/" target="_blank" rel="noopener noreferrer" class="w-full max-w-[180px] flex bg-white p-2 justify-center items-center">
                            <img src={Part_3}  className="inline-block object-contain" alt="Партнер"/>
                        </a>

                    </div>
                    <div className="w-full h-[1px]
                        bg-[linear-gradient(90deg,#b43125_0%,#245864_30.29%,#f5d858_56.25%,#95c8bf_76.92%,#245864_100%)]">
                    </div>
                </div>
                <div className="mb-4">
                    <h2 className="font-bold text-center uppercase text-[24px] sm:text-[26px] text-[#000] mb-3">Цифровий партнер</h2>
                    <div className="flex flex-col justify-center items-center gap-5 pb-5 md:flex-row">
                        <a href="https://www.linkos.ua/" target="_blank" rel="noopener noreferrer" class="w-full max-w-[160px] flex bg-white p-2 mx-auto   justify-center items-center">
                            <img src={Part_4}  className="inline-block object-contain" alt="Цифровий партнер"/>
                        </a>
                    </div>
                    <div className="w-full h-[1px]
                        bg-[linear-gradient(90deg,#b43125_0%,#245864_30.29%,#f5d858_56.25%,#95c8bf_76.92%,#245864_100%)]">
                    </div>
                </div>
            </div>

        </section>
    );
};

export default EventPartnersCenter;